module.exports = __webpack_public_path__ + "assets/media/day29.ba096a63.mp3";